import requests from './httpService';

const EventService = {
  getAllEvent() {
    return requests.get(`/event/list`);
  },
  getEvent(body) {
    return requests.post('/event/get', body);
  },
  createEvent(body) {
    return requests.post('/event/add', body);
  },
  getEventById(id) {
    return requests.get(`/event/${id}`);
  },
  deleteEvent(body) {
    return requests.delete(`/event/${body._id}`);
  },
  updateEvent(body) {
    return requests.put(`/event/${body._id}`, body);
  },
  addAllEvent(body) {
    return requests.post('/event/all', body);
  },
};

export default EventService;

